import chroma from "chroma-js";

export function darkOrLightColor(color) {
  return chroma(color).luminance() < 0.5 ? "#ffffff" : "#505050";
}

export const isColorDark = color =>
  chroma(color).luminance() < 0.5 ? false : true;
